(function (m, $) {

    m.init = function () {
        $.ajaxSetup({ cache: false });

        $(".ux-add-to-cart").click(m.selectExtra);
        $('.ux-counter-input-text').each(ooooby.saveGoogleAnalyticsCurrentSelectState);
    };

    m.selectExtra = function () {
        const productCard = $(this).closest(".ux-product");

        const inputCounter = productCard.find(".ux-counter-input-text");
        const quantity = inputCounter.val();
        const productId = productCard.data("productId");

        let deliveryFrequency = -1;
        const deliveryFrequencyRadio = productCard.find("input:radio[name='DeliveryFrequencyId']:checked");
        if (deliveryFrequencyRadio.length > 0)
            deliveryFrequency = deliveryFrequencyRadio.val();

        let oldValue = inputCounter.data('old') | 0;
        let newValue = inputCounter.val() | 0;
        inputCounter.data('old', newValue);

        let changedQuantity = newValue - oldValue;
        if (changedQuantity !== 0)
            m.sendGoogleAnalyticsAddToCart($(this), changedQuantity);
        
        $.post("/saveorder", { "productId": productId, "quantity": quantity, "deliveryFrequencyId": deliveryFrequency })
            .done(function (data) {
                if (data.success) {
                    $(".ux-shopping-basket").attr("data-count", data.cartCount);
                    m.showTemporaryMessage(data.message, false);
                } else if (data.message) {
                    m.showTemporaryMessage(data.message, true);
                }
            });
        
    };

}(window.ooooby = window.ooooby || {}, jQuery));

$(document).ready(function () {
    ooooby.init();
});